import { useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { post } from "@common/api/apiShared";
import { isNullOrWhitespace } from "@common/stringOperations";
import { useTranslation } from "@localization/useTranslation";
import { RiskTreatmentType } from "../../riskTreatmentType";
import { TreatmentDialogProps, RiskAvoidanceModel } from "./TreatmentDialogs.types";

export function useAvoidRiskDialog(props: TreatmentDialogProps) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();

    const { scenario } = props;

    // Avoid is terminal: re-avoiding an already-avoided risk is a no-op the backend rejects — block the save so
    // the user never hits an error. Switching to another treatment stays allowed.
    const isAlreadyAvoided = scenario.treatmentType === RiskTreatmentType.Avoid;

    const [reason, setReason] = useState("");

    const reasonValid = !isNullOrWhitespace(reason);

    const avoidMutation = useDotLegalMutation((model: RiskAvoidanceModel) => post(`/risk-assessments/${scenario.id}/treatment/avoid`, model));

    const onSave = () => {
        if (!reasonValid) return;

        avoidMutation.mutateAsync(
            { reason: reason.trim() },
            {
                onSuccess: () => {
                    snackbar.show(translateString("treatmentSaved"));
                    props.onSaved();
                },
            }
        );
    };

    return {
        isAlreadyAvoided,
        reason,
        setReason,
        okButtonDisabled: !reasonValid || isAlreadyAvoided,
        onSave,
        inProgress: avoidMutation.isLoading,
    };
}
